export default "__VITE_ASSET__BbLafyI0__"